import { render, staticRenderFns } from "./SselectClientSap.vue?vue&type=template&id=58ce3d14"
import script from "./SselectClientSap.vue?vue&type=script&lang=js"
export * from "./SselectClientSap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports